<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0">Certificaciones de tramites</h3>
    <hr />

    <v-progress-linear indeterminate v-if="loading" />

    <v-row>
      <v-col cols="3">
        <v-combobox
          v-model="filtroestudiante"
          :items="estudiantes"
          label="Carnet estudiante"
          loader-height="4"
          :loading="isloadingestudent"
          :disabled="isloadinprograma || loading"
          placeholder="tecla enter para buscar..."
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="6" sm="7">
        <v-select
          v-model="filtroprograma"
          :items="programas"
          label="Programas cursados:"
          item-text="nombre_compuesto"
          loader-height="4"
          :loading="isloadinprograma"
          :disabled="isloadinprograma || loading"
          placeholder="Seleccionar programa..."
          hide-details
          outlined
          dense
          return-object
        ></v-select>
      </v-col>
      <v-col cols="3" sm="2">
        <v-select
          v-model="iscursando"
          :items="iscursandovalues"
          label="Tipo certificacion:"
          loader-height="4"
          :loading="isloadinprograma"
          :disabled="!filtroprograma || loading"
          placeholder="Seleccionar tipo..."
          hide-details
          outlined
          dense
        ></v-select>
      </v-col>
    </v-row>

    <v-container>
      <v-img v-if="codigo_cert" src="img/tramheader.png" id="tramheader"></v-img>
      <div v-if="codigo_cert" id="templatecertpreview" style="margin:0">
        <div style="text-align:center">
          <h4 style="max-width:75%;display:inline-block;color:black">
            LA ESCUELA SUPERIOR DE NEGOCIOS “ESAM” EN CONVENIO CON LA UNIVERSIDAD NACIONAL SIGLO XX.
          </h4>
          <h2 style="color:black">CERTIFICA:</h2>
        </div>

        <!-- Curso y aprobo -->
        <p v-if="!iscursando" style="margin-bottom:1.5em">
          Por la documentación que cursó en nuestro poder, se evidenció:
        </p>
        <p v-if="!iscursando">
          Que, {{ participante }} con C.I. {{ participante_ci }}., curso y aprobó {{ programa }} iniciada el
          {{ programa_fecha }} hasta el {{ programa_fecha_fin }}. El título actualmente se encuentra en proceso de
          trámite con una carga horaria de {{ programa_carga_h }} horas académicas y {{ programa_credito }} horas de
          crédito. A continuación, se detalla el contenido desarrollado en la fase formativa del programa.
        </p>
        <p v-for="(m, ind) in programa_modulos" :key="ind" style="margin-left:2em">
          <span v-if="!iscursando">
            <b> MÓDULO {{ m.numero }}: </b> <span> {{ m.modulo.nombre }} </span>
          </span>
        </p>

        <!-- Curso y aprobo -->

        <!-- Cursando -->
        <p v-if="iscursando" style="margin-bottom:1.5em">
          Por la documentación de inscripción y asistencia que cursa en nuestro poder, se evidenció:
        </p>
        <p v-if="iscursando">
          Que, {{ participante }} con C.I. {{ participante_ci }}., actualmente se encuentra participando
          satisfactoriamente {{ programa }} iniciada {{ programa_fecha }} con una carga horaria de
          {{ programa_carga_h }} horas académicas y {{ programa_credito }} horas de crédito. Asimismo, recalcar que el
          programa se desarrolla la fase formativa conforme a la estructura curricular aprobada por la Universidad
          Nacional Siglo XX a efecto de sentar credibilidad al proceso de formación postgradual.
        </p>
        <!-- Cursando -->

        <p style="margin-top:1em">
          Es cuanto certifico en honor a la verdad y para los fines que al interesado así le convenga.
        </p>
        <p style="text-align:right">Tarija, {{ current_date }}</p>
      </div>
      <v-img v-if="codigo_cert" src="img/tramfooter.png"></v-img>
    </v-container>

    <v-progress-linear indeterminate v-if="loading" class="mt-4" />
    <p class="text-center mt-4" v-html="msg"></p>
    <div class="text-center">
      <v-btn
        v-if="codigo_cert"
        tile
        class="green darken-2 mt-1"
        :disabled="loading"
        dark
        @click="confirmaciongenerate()"
      >
        <v-icon left>mdi-arrow-down-bold-box</v-icon>
        Generar y Descargar Certificado
      </v-btn>
    </div>

    <div><ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" /></div>
  </div>
</template>

<script>
  import ABuscarPersona from '@/components/ABuscarPersona';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        img_logo: process.env.VUE_APP_LOGO,
        loadheader: false,
        loadfooter: false,
        loading: false,
        qrcode: null,
        header: null,
        footer: null,
        isloadingestudent: false,
        isloadinprograma: false,
        iscursando: false,
        iscursandovalues: [
          { text: 'Cursando', value: true },
          { text: 'Aprobado', value: false },
        ],
        filtroestudiante: null,
        filtroprograma: null,
        estudiantes: [],
        programas: [],
        timeoutHnd: 0,
        msg: '',
        codigo_cert: '',

        current_date: '',
        participante: 'la Arq. Patricia Elizabeth Saenz Chura',
        participante_ci: '4054101 OR',
        programa: 'el DIPLOMADO EN PERITAJE Y AVALUO DE BIENES INMUEBLES',
        programa_fecha: '3 de abril del año 2021',
        programa_fecha_fin: '3 de abril del año 2021',
        programa_carga_h: '800',
        programa_credito: '20',
        programa_modulos: [],
      };
    },
    components: { ABuscarPersona },
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
      filtroprograma: function() {
        if (!this.filtroprograma) return;
        if (!this.filtroprograma.postgrado.creditaje) this.filtroprograma.postgrado.creditaje = 0;

        this.programa = this.filtroprograma.nombre_compuesto;
        this.programa_carga_h = this.filtroprograma.postgrado.carga_horaria;
        this.programa_credito = this.filtroprograma.postgrado.creditaje;
        if (this.filtroprograma.fecha_inicio) {
          let fi = new Date(this.filtroprograma.fecha_inicio);
          this.programa_fecha = this.$refs.abuscarpersona.getfechastr(fi);
        }
        if (this.filtroprograma.fecha_fin) {
          let ff = new Date(this.filtroprograma.fecha_fin);
          this.programa_fecha_fin = this.$refs.abuscarpersona.getfechastr(ff);
        }

        if (!this.filtroprograma.programa_modulos) this.filtroprograma.programa_modulos = [];
        this.filtroprograma.programa_modulos = this.filtroprograma.programa_modulos.filter((m) => {
          return m.numero > 0;
        });
        this.programa_modulos = this.filtroprograma.programa_modulos;
        if (this.filtroestudiante) {
          this.getinscripcionmodulos();
        }
      },
    },
    methods: {
      resultadobusquedaest() {},
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      getinscripcionmodulos() {
        this.msg = '';
        this.loading = true;
        this.codigo_cert = '';
        let url = `${process.env.VUE_APP_API_REST}/api/v1/certtramites/inscripcionmodulos/${this.filtroprograma.id}/${this.filtroestudiante.id}`;
        //let url = `http://localhost:8090/api/v1/certtramites/inscripcionmodulos/${this.filtroprograma.id}/${this.filtroestudiante.id}`;
        let vue = this;
        let config = {
          method: 'get',
          url: url,
        };

        xaxios.request(config)
          .then(function(response) {
            if (!response.data) response.data = { data: [] };
            //window.console.log(response.data.data);
            let nota_minima = 71;
            let no_matriculados = [];
            let no_aprobados = [];
            vue.filtroprograma.programa_modulos.forEach((x) => {
              let existe = response.data.data.find((m) => m.programa_modulo_id == x.id);
              if (!existe) {
                no_matriculados.push(x);
              } else if (existe.nota_final < nota_minima || existe.nota_recuperatorio < nota_minima) {
                let ob = window.Object.assign({}, x);
                ob.nota_final = existe.nota_final;
                ob.nota_recuperatorio = existe.nota_recuperatorio;
                no_aprobados.push(ob);
              }
            });

            if (no_matriculados.length > 0) {
              vue.msg =
                '<p style="color:red;margin-bottom:0.1em;margin-top:1em">El estudiante no esta matriculado en los siguientes modulos del programa: </p>';
              no_matriculados.forEach((n) => {
                vue.msg += `${n.modulo.nombre}<br/>`;
              });
            }

            if (no_aprobados.length > 0) {
              vue.msg +=
                '<p style="color:red;margin-bottom:0.1em;margin-top:1em">El estudiante no tiene nota de aprobacion en los siguientes modulos del programa: </p>';
              no_aprobados.forEach((n) => {
                vue.msg += `${n.modulo.nombre} (NF:${n.nota_final}, NR:${n.nota_recuperatorio})<br/>`;
              });
            }

            if (no_matriculados.length == 0 && no_aprobados.length == 0) {
              vue.iscursando = false;
            } else {
              vue.msg =
                '<b>NOTA:</b> el estudiante esta en estado <b>cursando</b> en el sistema, debido al siguiente detalle <br/>' +
                vue.msg;
              vue.iscursando = true;
            }

            vue.codigo_cert = `${vue.filtroestudiante.id}0${vue.filtroprograma.id}`;
            vue.generarqr();
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      getDatos() {
        if (!this.filtroestudiante.seg_apellido) this.filtroestudiante.seg_apellido = '';
        if (!this.filtroestudiante.departamento) this.filtroestudiante.departamento = { extension: '' };
        this.participante = `${this.filtroestudiante.nombres} ${this.filtroestudiante.pri_apellido} ${this.filtroestudiante.seg_apellido}`;
        this.participante_ci = `${this.filtroestudiante.num_doc} ${this.filtroestudiante.departamento.extension}`;
        this.isloadinprograma = true;
        let q = `query{ getProgramasByPersona(student_id:${this.filtroestudiante.id}){id nombre_compuesto fecha_inicio fecha_fin sede{nombre} postgrado{carga_horaria,creditaje,categoria{id,nombre}} programa_modulos{id numero modulo{id nombre}}} } `;
        var sql = gql`
          ${q}
        `;
        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            let datos = data.data.getProgramasByPersona;
            this.programas = datos;
            this.isloadinprograma = false;
            window.console.log('personas res:', datos);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      cargarimages() {
        const vue = this;
        this.header = new Image();
        this.header.src = 'img/tramheader.png';
        this.header.setAttribute('crossorigin', 'anonymous');
        this.header.addEventListener(
          'load',
          () => {
            vue.loadheader = true;
          },
          false,
        );
        this.footer = new Image();
        this.footer.src = 'img/tramfooter.png';
        this.footer.setAttribute('crossorigin', 'anonymous');
        this.footer.addEventListener(
          'load',
          () => {
            vue.loadfooter = true;
          },
          false,
        );
      },
      generarqr() {
        let options = {
          text: 'https://esam.edu.bo/tramites/verificador?t=' + this.codigo_cert,
          width: 64,
          height: 64,
          version: 0,
          dotScale: 1,
          correctLevel: window.QRCode.CorrectLevel.L,
          onRenderingEnd: function() {},
        };
        let tag = document.createElement('div');
        //document.body.appendChild(tag);
        this.qrcode = new window.QRCode(tag, options);
        //window.console.log(this.qrcode._oDrawing.dataURL);
      },
      confirmaciongenerate() {
        var vue = this;
        var opt = {
          verification: 'anular',
          verificationHelp: 'Escriba "[+:verification]" para desmatricular.',
          okText: 'Generar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'soft',
        };
        var message = {
          title: 'Confirmar Emision',
          body:
            '<br> <b>NOTA:</b> Asegurese que todos los datos que aparecen en el certificado sean los correctos, una ves generado el certificado los datos no podran ser cambiados. </br></br>',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.guardarjsondatabase();
            dialog.close();
          })
          .catch(function() {});
      },
      guardarjsondatabase() {
        this.loading = true;
        this.msg = '';
        const vue = this;
        let mods = this.filtroprograma.programa_modulos.filter((x) => {
          delete x.__typename;
          delete x.modulo.__typename;
          return x;
        });
        let json = {
          current_date: this.current_date,
          participante: this.participante,
          participante_ci: this.participante_ci,
          programa: this.programa,
          programa_fecha: this.programa_fecha,
          programa_fecha_fin: this.programa_fecha_fin,
          programa_carga_h: this.programa_carga_h,
          programa_credito: this.programa_credito,
          programa_modulos: mods,
        };
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let urlc = `${process.env.VUE_APP_API_REST}/api/v1/certtramites/crear`;
        //let urlc = `http://localhost:8090/api/v1/certtramites/crear`;

        //window.console.log(JSON.stringify(json), this.codigo_cert);

        var data = JSON.stringify({
          codigo: this.codigo_cert,
          unidad_negocio: unidad,
          json: JSON.stringify(json),
          tipo: this.iscursando ? 1 : 2,
        });

        var config = {
          method: 'post',
          url: urlc,
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            vue.descargar(response.data.data);
            //vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
            vue.msg = 'No se pudo generar el certificado.';
          });
      },
      descargar(data) {
        let vue = this;
        let filename = this.participante + '.pdf';
        let elementoParaConvertir = window.$('#templatecertpreview').html();
        window
          .html2pdf()
          .set({
            margin: [2.1, 0.8, 2.6, 0.8], //top,left,bottom.right
            filename: filename,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 192,
              scale: 3, // A mayor escala, mejores gráficos, pero más peso
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' },
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait', // landscape o portrait
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          .get('pdf')
          .then((pdf) => {
            window.console.log(data);
            var totalPages = pdf.internal.getNumberOfPages();
            let numeracion = data.Numeracion.toString().padStart(7, '0');
            for (var i = 1; i <= totalPages; i++) {
              let w = pdf.internal.pageSize.getWidth();
              let h = pdf.internal.pageSize.getHeight();
              let hfoo = 2.6;
              pdf.setPage(i);
              pdf.setFontSize(8);
              pdf.setTextColor('#03305A');
              pdf.addImage(vue.header, 'JPEG', 0, 0, w, 1.6);
              pdf.addImage(vue.footer, 'JPEG', 0, h - hfoo, w, hfoo);
              pdf.addImage(vue.qrcode._oDrawing.dataURL, 'JPEG', 7.5, 2.0, 0.9, 0.9);
              pdf.text(numeracion, w - 0.6, 0.25);
            }
          })
          .output('datauristring')
          .then(function(pdfObj) {
            const linkSource = pdfObj;
            const downloadLink = document.createElement('a');
            downloadLink.href = linkSource;
            downloadLink.download = filename;
            downloadLink.click();
            vue.loading = false;
          })
          .catch((err) => {
            window.console.log(err);
          });
      },
    },
    mounted() {
      this.cargarimages();
      let ahora = new Date();
      this.current_date = this.$refs.abuscarpersona.getfechastr(ahora);
    },
  };
</script>
